import React, {useRef} from "react";
import ChatBox from "../components/chat/ChatBox";
import { ChatProvider, ChatType } from "../contexts/ChatContext";

function AdminAgent(){
      const chatBoxRef = useRef(null); // Create a reference for ChatBox
    
    return (
                 <section
            id="chat-section"
            className="flex flex-col h-screen bg-primaryBg from-primaryBg-from to-primaryBg-to"
          >
            <div className="flex-1 flex items-center justify-center">
              {/* <h3 className="text-2xl font-bold text-white text-center mb-6 mt-6">
                The Admin Agent
              </h3> */}
            </div>
            {/* <div className="flex-1">
              <ChatBox ref={chatBoxRef} chatType={ChatType.AGENT}/>
            </div> */}
          </section>
    );
}

export default AdminAgent;